"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnReferenceOn = void 0;
/**
 * Column reference's 'on' triggers of column actions.
 */
class ColumnReferenceOn {
    /**
     * Creates column reference "on" trigger from object.
     * Object must contain properties 'trigger' and 'action'.
     *
     * @param json JSON format parsed from SQL.
     */
    static fromObject(json) {
        const onInstance = new ColumnReferenceOn();
        onInstance.action = json.action.toLowerCase();
        onInstance.trigger = json.trigger.toLowerCase();
        return onInstance;
    }
    /**
     * JSON casting of this object calls this method.
     */
    toJSON() {
        return {
            trigger: this.trigger,
            action: this.action,
        };
    }
    /**
     * Create a deep clone of this model.
     */
    clone() {
        return ColumnReferenceOn.fromObject(this);
    }
}
exports.ColumnReferenceOn = ColumnReferenceOn;
